import styled from 'styled-components';

import { BREAKPOINTS } from '@/constants/breakpoints';
import {
  MAX_VISIBLE_CATEGORIES,
  MAX_VISIBLE_CATEGORIES_ON_TABLET
} from '@/constants/common';

export const Wrapper = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  row-gap: 15px;
  column-gap: 10px;

  & [data-label='chip']:nth-child(n + ${MAX_VISIBLE_CATEGORIES}) {
    display: none;
  }

  @media (max-width: ${BREAKPOINTS.tablet}) {
    & [data-label='chip']:nth-child(n + ${MAX_VISIBLE_CATEGORIES_ON_TABLET}) {
      display: none;
    }
  }

  // All categories button
  & [data-label='chip']:last-child {
    display: flex !important;
  }

  @media (max-width: ${BREAKPOINTS.mobile}) {
    row-gap: 10px;
  }
`;
